var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"82%","position":"absolute","left":"23%","top":"10%"}},[_c('h3',[_vm._v("Colaboradores cadastrados")]),_c('br'),_vm._l((_vm.data),function(element){return _c('div',{key:element.name,attrs:{"id":"list"}},[_vm._v(" "+_vm._s(element.name)+" / "+_vm._s(element.email)+" ")])}),_c('br'),_c('br')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }